import React, {useEffect, useState} from 'react';
import {curry} from 'ramda';
import {useDebouncedCallback} from 'use-debounce';
import wrap from 'wraptile';

import {BlankChangeEvent} from '@pluto/@types';
import Users from './Users';
import {HandleChangeProps, UserListFilterParams, UserOption, UsersContainerProps, UserStatusEnum,} from './UsersTypes';

export const onEffect = wrap((
    setUsers: (params?: UserListFilterParams) => void,
    isLoading: boolean,
    onHandleUnMount: () => void
) => {
    if (isLoading)
        setUsers();

    return onHandleUnMount;
});

export const handleUnMount = wrap((setUsers: (params?: UserListFilterParams) => void) => {
    setUsers();
});

export const getOptionSelected = (option: string, value: string) => {
    return option === value;
};

export const getOptionLabel = (option: string) => {
    return option || '';
};

export const findSelected = curry((value: string, user: UserOption) => user.email === value);

export const handleChange = curry((props: HandleChangeProps, _event: BlankChangeEvent, value: string | null) => {
    const {
        onChange,
        rows,
    } = props;

    if (!value)
        return onChange(null);

    const selected = rows.find(findSelected(value)) || null;
    onChange(selected);
});

export const handleDebounceCallback = curry((setUsers, name) => {
    setUsers({
        name,
        status: [UserStatusEnum.Active],
        limit: 20,
        offset: 0,
    })
});

export const handleDebounce = curry(({debouncedFunction, setUserInputValue}, e) => {
    const newValue = e?.target?.value
        || e?.target?.innerText.split(' ').find((item: string) => item.includes('@pluto'))
        || '';

    setUserInputValue(newValue);

    if (e?.target?.value || e?.target?.value === '') {
        debouncedFunction(newValue);
    }
    // in case we would need another requirements
    // else if (newValue) {
    //     debouncedFunction('');
    // }
});

export default function UsersContainer(props: UsersContainerProps) {
    const {
        setUsers,
        rows,
        onChange,
        isLoading,
        assignedUser,
    } = props;

    const [userInputValue, setUserInputValue] = useState<string>('');
    const debounceCallback = handleDebounceCallback(setUsers);
    const [debouncedFunction] = useDebouncedCallback(debounceCallback, 900);
    const onDebouncedInputChange = handleDebounce({
        debouncedFunction,
        setUserInputValue
    });
    const onSelectChange = handleChange({
        onChange,
        rows,
    });

    const fetchUsers = onEffect(setUsers, isLoading, handleUnMount(setUsers));

    useEffect(fetchUsers, []);

    return (
        <Users
            userInputValue={userInputValue}
            onInputChange={onDebouncedInputChange}
            assignedUser={assignedUser}
            opts={rows}
            getOptionSelected={getOptionSelected}
            getOptionLabel={getOptionLabel}
            onChange={onSelectChange as any}
        />
    );
}
